var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _rect, _g2, _g3, _path9, _path0, _g4, _path1, _path10, _g5, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g6, _path27, _path28, _g7, _path29, _path30, _g8, _path31, _path32, _path33, _g9, _path34, _g0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechFoundation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1570,
    height: 444,
    viewBox: "0 0 1570 444",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "flow-line-1",
    d: "M661.677 181.797L542.65 95.3453C533.424 88.644 522.313 85.0349 510.91 85.0349H137.868C126.618 85.0349 115.648 88.5481 106.491 95.0839L-15 181.797",
    stroke: "url(#paint0_linear_381_3334)",
    strokeWidth: 1.17414
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "flow-line-2",
    d: "M645.836 218.156H442.763C433.535 218.156 424.46 215.791 416.405 211.288L357.366 178.279C340.494 168.846 319.867 169.148 303.279 179.072L250.758 210.494C242.378 215.508 232.795 218.156 223.029 218.156H64.2344",
    stroke: "url(#paint1_linear_381_3334)",
    strokeWidth: 1.17414
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "flow-line-3",
    d: "M664.615 246.304L551.915 326.594C542.765 333.113 531.811 336.616 520.577 336.616H144.349C133.449 336.616 122.805 333.318 113.815 327.156L36.0625 273.867",
    stroke: "url(#paint2_linear_381_3334)",
    strokeWidth: 1.17414
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "flow-line-4",
    d: "M797.242 323.128L722.686 387.889C712.86 396.424 700.282 401.124 687.267 401.124H447.038C435.858 401.124 424.953 397.654 415.828 391.193L327.148 328.406",
    stroke: "url(#paint3_linear_381_3334)",
    strokeWidth: 1.17414
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "flow-line-5",
    d: "M791.961 114.357L877.566 52.4658C886.774 45.8085 897.848 42.2249 909.21 42.2249H1156.8C1166.54 42.2249 1176.09 44.8555 1184.45 49.8386L1269.1 100.282",
    stroke: "url(#paint4_linear_381_3334)",
    strokeWidth: 1.17414
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "flow-line-6",
    d: "M948.664 180.038L1063.71 98.0025C1072.86 91.4753 1083.82 87.967 1095.06 87.967H1470.16C1480.29 87.967 1490.22 90.8149 1498.8 96.1854L1567.24 138.987",
    stroke: "url(#paint5_linear_381_3334)",
    strokeWidth: 1.17414
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "flow-line-7",
    d: "M962.156 218.156H1173.49C1180.81 218.156 1188.06 216.667 1194.78 213.78L1260.4 185.625C1275.53 179.131 1292.81 179.897 1307.31 187.706L1362.75 217.563C1370.62 221.801 1379.42 224.02 1388.35 224.02H1532.61",
    stroke: "url(#paint6_linear_381_3334)",
    strokeWidth: 1.17414
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "flow-line-8",
    d: "M932.82 246.304L1052.34 343.308C1061.96 351.119 1073.98 355.382 1086.38 355.382H1467.51C1478.2 355.382 1488.65 352.212 1497.53 346.273L1569 298.497",
    stroke: "url(#paint7_linear_381_3334)",
    strokeWidth: 1.17414
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    r: 4.5,
    fill: "#8B5CFF",
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "6s",
    begin: "0s",
    repeatCount: "indefinite",
    rotate: "auto"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#flow-line-1"
  }))), /*#__PURE__*/React.createElement("circle", {
    r: 4.5,
    fill: "#8B5CFF",
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "6s",
    begin: "0s",
    repeatCount: "indefinite",
    rotate: "auto"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#flow-line-2"
  }))), /*#__PURE__*/React.createElement("circle", {
    r: 4.5,
    fill: "#8B5CFF",
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "6s",
    begin: "0s",
    repeatCount: "indefinite",
    rotate: "auto"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#flow-line-3"
  }))), /*#__PURE__*/React.createElement("circle", {
    r: 4.5,
    fill: "#8B5CFF",
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "6s",
    begin: "0s",
    repeatCount: "indefinite",
    rotate: "auto"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#flow-line-4"
  }))), /*#__PURE__*/React.createElement("circle", {
    r: 4.5,
    fill: "#8B5CFF",
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "6s",
    begin: "0s",
    repeatCount: "indefinite",
    rotate: "auto"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#flow-line-5"
  }))), /*#__PURE__*/React.createElement("circle", {
    r: 4.5,
    fill: "#8B5CFF",
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "6s",
    begin: "0s",
    repeatCount: "indefinite",
    rotate: "auto"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#flow-line-6"
  }))), /*#__PURE__*/React.createElement("circle", {
    r: 4.5,
    fill: "#8B5CFF",
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "6s",
    begin: "0s",
    repeatCount: "indefinite",
    rotate: "auto"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#flow-line-7"
  }))), /*#__PURE__*/React.createElement("circle", {
    r: 4.5,
    fill: "#8B5CFF",
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "6s",
    begin: "0s",
    repeatCount: "indefinite",
    rotate: "auto"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#flow-line-8"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 639.969,
    y: 174.76,
    width: 328.655,
    height: 82.1011,
    rx: 41.0505,
    fill: "#0E0924"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M639.969 215.81C639.969 193.138 658.348 174.76 681.019 174.76H927.573C950.245 174.76 968.624 193.138 968.624 215.81C968.624 238.482 950.245 256.861 927.573 256.861H681.019C658.348 256.861 639.969 238.482 639.969 215.81Z",
    fill: "url(#paint8_linear_381_3334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.969 215.81C639.969 193.138 658.348 174.76 681.019 174.76H927.573C950.245 174.76 968.624 193.138 968.624 215.81C968.624 238.482 950.245 256.861 927.573 256.861H681.019C658.348 256.861 639.969 238.482 639.969 215.81Z",
    fill: "#744DFF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_381_3334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M692.828 215.81C692.828 154.249 742.733 104.344 804.294 104.344C865.854 104.344 915.759 154.249 915.759 215.81C915.759 277.371 865.854 327.275 804.294 327.275C742.733 327.275 692.828 277.371 692.828 215.81Z",
    fill: "#744DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.571 246.998C848.324 247.745 848.921 248.633 849.329 249.611C849.737 250.59 849.947 251.639 849.947 252.699C849.947 253.759 849.737 254.809 849.329 255.787C848.921 256.766 848.324 257.654 847.571 258.4C846.825 259.153 845.937 259.751 844.958 260.158C843.98 260.566 842.93 260.776 841.87 260.776C840.81 260.776 839.76 260.566 838.782 260.158C837.803 259.751 836.915 259.153 836.169 258.4C836.028 258.259 835.866 258.098 835.765 257.936C834.52 256.511 833.822 254.689 833.796 252.796C833.77 250.903 834.418 249.063 835.624 247.604C836.3 246.766 837.137 246.073 838.087 245.567C839.037 245.06 840.079 244.751 841.151 244.657C842.223 244.562 843.303 244.685 844.326 245.018C845.35 245.352 846.295 245.888 847.107 246.595C847.268 246.696 847.43 246.857 847.571 246.998ZM804.768 259.995C805.676 259.995 806.524 260.136 807.331 260.418C808.936 260.954 810.331 261.981 811.32 263.353C812.309 264.726 812.841 266.375 812.84 268.067C812.84 272.527 809.228 276.139 804.768 276.139C800.308 276.139 796.696 272.527 796.696 268.067C796.696 267.865 796.696 267.663 796.716 267.461C797.019 263.284 800.51 259.995 804.768 259.995ZM770.683 245.202C771.652 245.606 772.58 246.191 773.367 246.998C774.255 247.886 774.901 248.936 775.284 250.046C776.213 252.689 775.728 255.696 773.771 257.936C773.67 258.098 773.508 258.259 773.367 258.4C772.621 259.153 771.733 259.751 770.754 260.158C769.776 260.566 768.726 260.776 767.666 260.776C766.606 260.776 765.557 260.566 764.578 260.158C763.6 259.751 762.712 259.153 761.965 258.4C761.212 257.654 760.615 256.766 760.207 255.787C759.799 254.809 759.589 253.759 759.589 252.699C759.589 251.639 759.799 250.59 760.207 249.611C760.615 248.633 761.212 247.745 761.965 246.998C762.106 246.857 762.268 246.696 762.429 246.595C763.543 245.624 764.903 244.98 766.36 244.734C767.817 244.488 769.313 244.65 770.683 245.202ZM824.363 228.735C824.747 229.663 824.949 230.672 824.949 231.742C824.949 233.72 824.222 235.536 823.031 236.948C821.993 238.186 820.605 239.081 819.05 239.516C817.494 239.952 815.844 239.908 814.313 239.39C813.248 239.037 812.27 238.462 811.442 237.704C810.614 236.946 809.956 236.021 809.51 234.991C809.046 234.002 808.804 232.892 808.804 231.742C808.804 230.127 809.289 228.634 810.116 227.363C811.387 225.365 813.526 223.993 815.988 223.71C816.291 223.69 816.574 223.67 816.876 223.67C818.487 223.67 820.061 224.153 821.395 225.056C822.73 225.959 823.763 227.24 824.363 228.735ZM857.237 207.525C861.697 207.525 865.31 211.138 865.31 215.597C865.31 220.057 861.697 223.67 857.237 223.67C857.036 223.67 856.834 223.67 856.632 223.649C855.128 223.534 853.687 223.001 852.471 222.109C851.255 221.218 850.312 220.004 849.75 218.604C849.359 217.65 849.16 216.628 849.165 215.597C849.165 214.407 849.428 213.277 849.912 212.268C851.082 209.644 853.625 207.767 856.632 207.545C856.834 207.525 857.036 207.525 857.237 207.525ZM847.571 172.795C848.324 173.541 848.921 174.429 849.329 175.407C849.737 176.386 849.947 177.436 849.947 178.496C849.947 179.556 849.737 180.605 849.329 181.584C848.921 182.562 848.324 183.45 847.571 184.197C847.43 184.338 847.268 184.499 847.107 184.6C845.574 185.935 843.59 186.637 841.558 186.562C839.526 186.487 837.599 185.641 836.169 184.197C835.705 183.732 835.321 183.248 835.019 182.723C833.182 179.797 833.424 175.943 835.765 173.259C835.866 173.097 836.028 172.936 836.169 172.795C836.915 172.042 837.803 171.444 838.782 171.036C839.76 170.629 840.81 170.419 841.87 170.419C842.93 170.419 843.98 170.629 844.958 171.036C845.937 171.444 846.825 172.042 847.571 172.795ZM812.84 187.345C815.847 187.345 818.471 188.979 819.843 191.421C820.529 192.612 820.912 193.964 820.912 195.417C820.912 196.608 820.65 197.738 820.166 198.747C819.596 200.024 818.702 201.129 817.573 201.954C816.443 202.779 815.118 203.294 813.728 203.449C813.426 203.469 813.143 203.489 812.84 203.489C809.591 203.489 806.806 201.572 805.535 198.807C805.03 197.778 804.768 196.628 804.768 195.417C804.768 194.448 804.95 193.52 805.273 192.652C805.716 191.41 806.46 190.296 807.439 189.412C808.418 188.528 809.602 187.901 810.883 187.587C811.508 187.425 812.174 187.345 812.84 187.345ZM804.768 155.056C809.228 155.056 812.84 158.668 812.84 163.128C812.84 163.33 812.84 163.532 812.82 163.734C812.667 165.764 811.753 167.662 810.259 169.047C808.766 170.432 806.805 171.201 804.768 171.2C800.51 171.2 797.019 167.911 796.716 163.734C796.696 163.532 796.696 163.33 796.696 163.128C796.696 158.668 800.308 155.056 804.768 155.056ZM789.35 213.922C788.378 215.429 786.932 216.568 785.239 217.16C783.547 217.753 781.706 217.764 780.007 217.192C778.658 216.743 777.452 215.944 776.512 214.877C775.573 213.81 774.933 212.512 774.659 211.117C774.302 209.344 774.554 207.503 775.375 205.891C776.195 204.28 777.536 202.992 779.179 202.238C780.208 201.733 781.359 201.471 782.57 201.471C785.819 201.471 788.603 203.388 789.875 206.153C790.379 207.182 790.642 208.332 790.642 209.543C790.642 211.158 790.157 212.651 789.35 213.922ZM771.41 185.65C768.544 187.163 764.972 186.82 762.429 184.6C762.268 184.499 762.106 184.338 761.965 184.197C761.212 183.45 760.615 182.562 760.207 181.584C759.799 180.605 759.589 179.556 759.589 178.496C759.589 177.436 759.799 176.386 760.207 175.407C760.615 174.429 761.212 173.541 761.965 172.795C762.712 172.042 763.6 171.444 764.578 171.036C765.557 170.629 766.606 170.419 767.666 170.419C768.726 170.419 769.776 170.629 770.754 171.036C771.733 171.444 772.621 172.042 773.367 172.795C773.508 172.936 773.67 173.097 773.771 173.259C774.763 174.398 775.413 175.794 775.646 177.287C775.878 178.78 775.683 180.308 775.083 181.694C774.335 183.386 773.042 184.779 771.41 185.65ZM752.904 207.545C756.557 207.828 759.523 210.512 760.21 214.023C760.434 215.144 760.417 216.299 760.161 217.412C759.906 218.526 759.416 219.572 758.725 220.482C758.035 221.392 757.159 222.145 756.155 222.691C755.152 223.237 754.043 223.564 752.904 223.649C752.702 223.67 752.501 223.67 752.299 223.67C747.839 223.67 744.227 220.057 744.227 215.597C744.227 211.138 747.839 207.525 752.299 207.525C752.501 207.525 752.702 207.525 752.904 207.545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.33 215.597C867.33 210.405 863.371 206.163 858.319 205.616C856.926 198.151 853.987 191.059 849.692 184.796C851.152 183.02 851.954 180.795 851.963 178.496C851.963 175.799 850.913 173.267 849.008 171.362C845.335 167.689 839.535 167.491 835.576 170.678C829.313 166.381 822.22 163.441 814.754 162.046C814.203 156.997 809.963 153.038 804.771 153.038C799.578 153.038 795.338 156.997 794.789 162.048C787.323 163.443 780.231 166.383 773.967 170.68C770.01 167.491 764.208 167.689 760.535 171.362C759.595 172.296 758.85 173.408 758.343 174.633C757.836 175.857 757.577 177.17 757.58 178.496C757.58 180.826 758.406 183.01 759.851 184.796C755.556 191.059 752.617 198.151 751.224 205.616C746.17 206.163 742.211 210.403 742.211 215.597C742.211 220.792 746.17 225.032 751.222 225.579C752.615 233.044 755.554 240.136 759.849 246.399C758.389 248.175 757.587 250.4 757.578 252.699C757.578 255.395 758.628 257.928 760.533 259.833C761.469 260.771 762.582 261.514 763.806 262.02C765.031 262.527 766.344 262.786 767.669 262.783C769.965 262.77 772.187 261.971 773.965 260.517C780.229 264.813 787.322 267.752 794.789 269.146C795.336 274.198 799.576 278.157 804.771 278.157C809.963 278.157 814.203 274.198 814.752 269.146C822.218 267.752 829.311 264.813 835.576 260.517C837.354 261.97 839.576 262.769 841.872 262.783C844.455 262.783 847.041 261.801 849.008 259.833C849.948 258.898 850.693 257.787 851.2 256.562C851.707 255.338 851.966 254.025 851.963 252.699C851.955 250.4 851.153 248.175 849.692 246.399C853.987 240.136 856.926 233.044 858.319 225.579C863.371 225.032 867.33 220.792 867.33 215.597ZM835.552 244.9L825.692 236.555C826.518 235.085 826.958 233.428 826.969 231.742C826.969 231.128 826.892 230.535 826.787 229.954L848.823 221.139C850.119 223.083 852.051 224.517 854.287 225.195C852.993 231.86 850.367 238.196 846.566 243.822C844.827 242.903 842.855 242.516 840.897 242.708C838.939 242.899 837.081 243.661 835.552 244.9ZM810.825 231.742C810.825 228.404 813.541 225.688 816.879 225.688C820.217 225.688 822.933 228.404 822.933 231.742C822.933 235.08 820.217 237.796 816.879 237.796C813.541 237.796 810.825 235.08 810.825 231.742ZM774.804 245.565C774.298 245.062 773.739 244.615 773.138 244.23L781.377 219.512C781.773 219.561 782.162 219.634 782.572 219.634C783.912 219.633 785.239 219.365 786.475 218.844C787.71 218.323 788.828 217.56 789.764 216.6L807.501 228.077C807.036 229.243 806.794 230.486 806.789 231.742C806.789 232.474 806.875 233.185 807.025 233.873L776.237 247.418C775.833 246.747 775.353 246.125 774.804 245.565ZM762.973 243.824C759.172 238.198 756.546 231.862 755.252 225.197C759.356 223.93 762.367 220.152 762.385 215.64L773.273 213.462C774.141 215.476 775.64 217.154 777.545 218.241L769.366 242.779C767.178 242.413 764.93 242.781 762.973 243.824ZM767.669 188.58C768.581 188.58 769.483 188.412 770.369 188.166L776.578 201.471C775.318 202.399 774.292 203.607 773.581 205.001C772.871 206.396 772.496 207.936 772.486 209.501L761.598 211.678C761.018 210.327 760.149 209.118 759.054 208.137C757.958 207.156 756.661 206.426 755.254 205.998C756.547 199.333 759.172 192.997 762.973 187.371C764.416 188.15 766.028 188.565 767.669 188.58ZM774.804 185.629C775.25 185.181 775.652 184.692 776.007 184.168L802.902 193.948C802.829 194.432 802.752 194.914 802.752 195.417C802.752 196.226 802.874 197.003 803.053 197.758L790.642 203.552C788.802 201.078 785.884 199.453 782.572 199.453C781.763 199.453 780.986 199.574 780.231 199.754L773.961 186.318C774.243 186.091 774.542 185.892 774.804 185.629ZM812.843 189.363C816.181 189.363 818.897 192.079 818.897 195.417C818.897 198.755 816.181 201.471 812.843 201.471C809.505 201.471 806.789 198.755 806.789 195.417C806.789 192.079 809.505 189.363 812.843 189.363ZM834.737 185.629C835.673 186.567 836.785 187.31 838.01 187.817C839.235 188.323 840.547 188.582 841.872 188.58C843.495 188.58 845.099 188.146 846.568 187.371C850.369 192.997 852.995 199.333 854.289 205.998C852.209 206.634 850.39 207.926 849.105 209.683L822.663 197.663C822.826 196.939 822.933 196.192 822.933 195.417C822.92 194.351 822.735 193.294 822.386 192.287L834.513 185.357C834.593 185.444 834.652 185.547 834.737 185.629ZM817.797 221.744L815.934 204.972C817.957 204.321 819.723 203.047 820.977 201.332L847.422 213.351C847.247 214.087 847.156 214.841 847.15 215.597C847.15 216.211 847.226 216.804 847.331 217.387L825.296 226.2C824.46 224.943 823.352 223.889 822.054 223.118C820.756 222.346 819.301 221.877 817.797 221.744ZM811.924 205.414L813.787 222.186C812.24 222.676 810.834 223.532 809.688 224.683L791.95 213.204C792.415 212.039 792.657 210.797 792.662 209.543C792.662 208.734 792.541 207.957 792.362 207.202L804.771 201.411C805.614 202.543 806.688 203.485 807.92 204.175C809.153 204.865 810.518 205.287 811.924 205.414ZM776.518 209.543C776.518 206.205 779.234 203.489 782.572 203.489C785.91 203.489 788.626 206.205 788.626 209.543C788.626 212.881 785.91 215.597 782.572 215.597C779.234 215.597 776.518 212.881 776.518 209.543ZM863.294 215.597C863.294 218.935 860.578 221.652 857.24 221.652C853.902 221.652 851.186 218.935 851.186 215.597C851.186 212.26 853.902 209.543 857.24 209.543C860.578 209.543 863.294 212.26 863.294 215.597ZM841.872 172.445C842.668 172.443 843.456 172.598 844.191 172.902C844.926 173.205 845.594 173.65 846.157 174.212C846.719 174.775 847.165 175.442 847.469 176.177C847.773 176.912 847.928 177.7 847.927 178.496C847.929 179.291 847.773 180.078 847.469 180.813C847.165 181.548 846.718 182.215 846.155 182.776C845.018 183.909 843.478 184.545 841.873 184.545C840.268 184.545 838.729 183.909 837.592 182.776C836.45 181.634 835.82 180.114 835.82 178.496C835.82 176.877 836.45 175.357 837.592 174.215C838.154 173.653 838.821 173.206 839.555 172.903C840.29 172.599 841.077 172.444 841.872 172.445ZM814.368 166.081C821.031 167.375 827.365 170 832.991 173.798C832.207 175.24 831.791 176.854 831.78 178.496C831.78 179.682 832.016 180.826 832.408 181.912L820.384 188.784C818.534 186.681 815.856 185.327 812.843 185.327C812.695 185.327 812.558 185.363 812.411 185.371L809.117 172.195C810.366 171.592 811.477 170.738 812.381 169.686C813.284 168.633 813.961 167.406 814.368 166.081ZM804.771 157.074C808.108 157.074 810.825 159.79 810.825 163.128C810.825 166.466 808.108 169.182 804.771 169.182C801.433 169.182 798.716 166.466 798.716 163.128C798.716 159.79 801.433 157.074 804.771 157.074ZM804.771 173.218C804.918 173.218 805.055 173.182 805.202 173.174L808.496 186.35C806.754 187.188 805.289 188.508 804.274 190.154L777.569 180.443C777.692 179.807 777.759 179.157 777.759 178.496C777.759 176.823 777.311 175.234 776.548 173.798C782.173 169.999 788.507 167.374 795.171 166.081C796.444 170.197 800.24 173.218 804.771 173.218ZM763.388 174.215C764.569 173.035 766.121 172.445 767.671 172.445C768.466 172.443 769.254 172.598 769.989 172.902C770.724 173.205 771.392 173.65 771.955 174.212C772.517 174.775 772.963 175.442 773.267 176.177C773.571 176.912 773.726 177.7 773.725 178.496C773.727 179.291 773.572 180.078 773.268 180.813C772.963 181.548 772.517 182.215 771.953 182.776C770.816 183.909 769.277 184.545 767.672 184.545C766.067 184.545 764.527 183.909 763.39 182.776C762.248 181.634 761.619 180.114 761.619 178.496C761.619 176.877 762.244 175.36 763.388 174.215ZM746.247 215.597C746.247 212.26 748.963 209.543 752.301 209.543C755.639 209.543 758.355 212.26 758.355 215.597C758.355 218.935 755.639 221.652 752.301 221.652C748.963 221.652 746.247 218.935 746.247 215.597ZM763.388 256.98C762.246 255.837 761.617 254.318 761.617 252.699C761.617 251.081 762.246 249.561 763.388 248.419C763.95 247.856 764.618 247.41 765.353 247.107C766.088 246.803 766.875 246.647 767.671 246.649C768.466 246.647 769.254 246.802 769.989 247.105C770.724 247.409 771.392 247.854 771.955 248.416C772.517 248.978 772.963 249.646 773.267 250.381C773.571 251.116 773.726 251.904 773.725 252.699C773.727 253.494 773.572 254.282 773.268 255.017C772.963 255.752 772.517 256.419 771.953 256.98C770.816 258.113 769.276 258.749 767.671 258.749C766.065 258.749 764.525 258.113 763.388 256.98ZM795.173 265.114C788.509 263.82 782.176 261.196 776.55 257.397C777.313 255.96 777.761 254.372 777.761 252.699C777.761 252.197 777.688 251.71 777.618 251.222L808.665 237.56C809.51 238.736 810.597 239.718 811.854 240.438L805.967 258.096C805.57 258.049 805.18 257.976 804.771 257.976C800.24 257.976 796.444 260.997 795.173 265.114ZM804.771 274.121C801.433 274.121 798.716 271.405 798.716 268.067C798.716 264.729 801.433 262.013 804.771 262.013C808.108 262.013 810.825 264.729 810.825 268.067C810.825 271.405 808.108 274.121 804.771 274.121ZM809.797 259.369L815.684 241.711C816.08 241.759 816.469 241.832 816.879 241.832C819.136 241.823 821.323 241.049 823.084 239.638L832.985 248.015C832.207 249.455 831.794 251.063 831.782 252.699C831.782 254.372 832.23 255.962 832.993 257.399C827.367 261.198 821.034 263.822 814.37 265.116C813.623 262.694 811.99 260.641 809.797 259.369ZM846.153 256.98C845.016 258.114 843.477 258.751 841.871 258.751C840.266 258.751 838.726 258.114 837.59 256.98C836.448 255.837 835.818 254.318 835.818 252.699C835.818 251.081 836.448 249.561 837.59 248.419C838.152 247.856 838.82 247.41 839.555 247.107C840.289 246.803 841.077 246.647 841.872 246.649C842.668 246.647 843.456 246.802 844.191 247.105C844.926 247.409 845.594 247.854 846.157 248.416C846.719 248.978 847.165 249.646 847.469 250.381C847.773 251.116 847.928 251.904 847.927 252.699C847.927 254.318 847.297 255.835 846.153 256.98Z",
    fill: "#0E0924"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M144.629 41.6379C167.624 41.638 186.298 60.2793 186.298 83.2756C186.298 106.272 167.624 124.913 144.629 124.913C121.634 124.913 102.96 106.272 102.96 83.2756C102.96 60.2792 121.634 41.6379 144.629 41.6379Z",
    fill: "#0E0924"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M144.629 41.6379C167.624 41.638 186.298 60.2793 186.298 83.2756C186.298 106.272 167.624 124.913 144.629 124.913C121.634 124.913 102.96 106.272 102.96 83.2756C102.96 60.2792 121.634 41.6379 144.629 41.6379Z",
    stroke: "url(#ring-stroke-unified)",
    strokeWidth: 1.17414
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_381_3334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.446 67.1741C136.89 67.1741 136.809 70.1067 136.809 70.7104C136.809 71.6261 136.809 74.3741 136.809 74.3741H144.591V75.474C144.591 75.474 136.489 75.474 133.718 75.474C131.406 75.474 128.5 76.88 128.5 83.1104C128.5 88.8334 130.767 91.0467 133.054 91.0467C133.734 91.0467 135.773 91.0467 135.773 91.0467C135.773 91.0467 135.773 88.2059 135.773 87.2285C135.773 85.6311 136.564 82.674 140.254 82.674C144.883 82.674 146.064 82.674 147.973 82.674C149.108 82.674 152.309 82.1806 152.309 78.4832C152.309 74.5699 152.309 73.2788 152.309 71.4376C152.309 70.5204 152.152 67.1741 144.446 67.1741ZM140.155 69.6378C140.929 69.6378 141.555 70.2632 141.555 71.0379C141.555 71.812 140.929 72.4381 140.155 72.4381C139.38 72.4381 138.755 71.8123 138.755 71.0379C138.755 70.2632 139.38 69.6378 140.155 69.6378Z",
    fill: "url(#paint10_linear_381_3334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.551 99.1736C152.103 99.1736 152.197 96.1857 152.197 95.6373C152.197 94.7215 152.197 91.9736 152.197 91.9736H144.406V90.8737C144.406 90.8737 152.56 90.8737 155.278 90.8737C157.608 90.8737 160.497 89.4325 160.497 83.2373C160.497 76.4527 157.431 75.301 155.942 75.301C155.263 75.301 153.224 75.301 153.224 75.301C153.224 75.301 153.224 78.273 153.224 79.1192C153.224 80.7166 152.459 83.6737 148.742 83.6737C144.114 83.6737 143.076 83.6737 141.024 83.6737C139.892 83.6737 136.688 84.2252 136.688 87.8645C136.688 92.0754 136.688 93.178 136.688 94.91C136.688 96.4315 137.617 99.1736 144.551 99.1736ZM148.842 96.7099C148.068 96.7099 147.442 96.0842 147.442 95.3098C147.442 94.5354 148.068 93.9096 148.842 93.9096C149.616 93.9096 150.242 94.5354 150.242 95.3098C150.242 96.0842 149.616 96.7099 148.842 96.7099Z",
    fill: "url(#paint11_linear_381_3334)"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M411.074 169.481C434.069 169.481 452.743 188.123 452.743 211.119C452.743 234.115 434.069 252.757 411.074 252.757C388.079 252.757 369.405 234.115 369.405 211.119C369.405 188.123 388.079 169.481 411.074 169.481Z",
    fill: "#0E0924"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M411.074 169.481C434.069 169.481 452.743 188.123 452.743 211.119C452.743 234.115 434.069 252.757 411.074 252.757C388.079 252.757 369.405 234.115 369.405 211.119C369.405 188.123 388.079 169.481 411.074 169.481Z",
    stroke: "url(#ring-stroke-unified)",
    strokeWidth: 1.17414
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_381_3334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.079 203.344L418.388 205.942C422.807 210.209 422.807 217.074 418.388 221.277C413.969 225.544 406.86 225.544 402.508 221.277C398.089 217.01 398.089 210.145 402.508 205.942L409.517 199.173L410.514 198.211V193.11L399.949 203.312C394.069 208.99 394.069 218.165 399.949 223.843C405.83 229.522 415.331 229.522 421.112 223.843C426.959 218.165 426.959 209.054 421.079 203.344Z",
    fill: "#EE4C2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.796 202.734C416.879 202.734 417.756 201.887 417.756 200.842C417.756 199.796 416.879 198.949 415.796 198.949C414.714 198.949 413.836 199.796 413.836 200.842C413.836 201.887 414.714 202.734 415.796 202.734Z",
    fill: "#EE4C2C"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M246.746 297.324C269.741 297.324 288.415 315.965 288.415 338.962C288.415 361.958 269.741 380.599 246.746 380.599C223.751 380.599 205.077 361.958 205.077 338.962C205.077 315.965 223.751 297.324 246.746 297.324Z",
    fill: "#0E0924"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M246.746 297.324C269.741 297.324 288.415 315.965 288.415 338.962C288.415 361.958 269.741 380.599 246.746 380.599C223.751 380.599 205.077 361.958 205.077 338.962C205.077 315.965 223.751 297.324 246.746 297.324Z",
    stroke: "url(#ring-stroke-unified)",
    strokeWidth: 1.17414
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M257.146 334.603C256.617 334.603 256.12 334.808 255.748 335.18L254.245 336.679C253.839 337.084 253.631 337.645 253.674 338.221C253.677 338.253 253.68 338.284 253.683 338.317C253.737 338.758 253.931 339.157 254.245 339.469C254.462 339.685 254.7 339.822 254.99 339.917C255.005 340.004 255.013 340.093 255.013 340.181C255.013 340.578 254.859 340.951 254.578 341.231L254.486 341.323C253.984 341.152 253.565 340.902 253.187 340.524C252.685 340.024 252.352 339.391 252.227 338.697L252.21 338.6L252.134 338.662C252.082 338.704 252.033 338.748 251.987 338.794L250.484 340.293C249.714 341.062 249.714 342.314 250.484 343.082C250.869 343.466 251.376 343.659 251.883 343.659C252.39 343.659 252.895 343.466 253.28 343.082L254.784 341.583C255.554 340.814 255.554 339.563 254.784 338.794C254.578 338.589 254.333 338.435 254.056 338.336C254.041 338.246 254.033 338.155 254.033 338.067C254.033 337.635 254.203 337.226 254.516 336.914C255.02 337.085 255.466 337.363 255.843 337.739C256.344 338.238 256.675 338.87 256.802 339.566L256.82 339.663L256.896 339.601C256.948 339.559 256.997 339.515 257.043 339.468L258.547 337.969C259.317 337.2 259.318 335.948 258.547 335.18C258.174 334.808 257.678 334.603 257.148 334.603H257.146Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M256.335 329.121H236.665C231.06 329.121 226.5 333.668 226.5 339.258C226.5 344.848 231.06 349.395 236.665 349.395H256.335C261.94 349.395 266.5 344.848 266.5 339.258C266.5 333.668 261.94 329.121 256.335 329.121ZM246.633 345.014C246.309 345.081 245.944 345.093 245.696 344.835C245.604 345.044 245.391 344.934 245.226 344.907C245.211 344.949 245.198 344.987 245.184 345.029C244.636 345.066 244.225 344.508 243.964 344.087C243.445 343.808 242.857 343.637 242.327 343.344C242.297 343.827 242.403 344.425 241.942 344.736C241.919 345.664 243.349 344.846 243.48 345.537C243.378 345.548 243.266 345.521 243.184 345.599C242.811 345.961 242.383 345.325 241.953 345.588C241.376 345.878 241.318 346.115 240.603 346.175C240.564 346.115 240.58 346.075 240.614 346.039C240.815 345.806 240.829 345.531 241.173 345.432C240.819 345.376 240.523 345.571 240.225 345.725C239.838 345.883 239.841 345.368 239.245 345.752C239.179 345.698 239.211 345.65 239.249 345.608C239.4 345.424 239.599 345.396 239.824 345.406C238.719 344.792 238.199 346.157 237.688 345.478C237.535 345.519 237.477 345.657 237.38 345.754C237.297 345.663 237.36 345.552 237.364 345.445C237.264 345.398 237.138 345.376 237.168 345.217C236.973 345.151 236.836 345.266 236.691 345.376C236.56 345.275 236.78 345.127 236.82 345.021C236.937 344.818 237.203 344.98 237.339 344.834C237.723 344.616 238.258 344.969 238.698 344.91C239.036 344.952 239.455 344.605 239.285 344.26C238.923 343.799 238.987 343.195 238.979 342.644C238.934 342.323 238.161 341.913 237.937 341.566C237.661 341.254 237.445 340.892 237.23 340.536C236.452 339.035 236.697 337.106 235.717 335.712C235.274 335.956 234.697 335.841 234.315 335.513C234.108 335.701 234.099 335.946 234.083 336.207C233.588 335.713 233.65 334.78 234.045 334.231C234.207 334.014 234.4 333.836 234.615 333.679C234.664 333.643 234.681 333.609 234.679 333.554C235.071 331.798 237.74 332.137 238.584 333.381C239.196 334.146 239.381 335.159 240.075 335.869C241.009 336.889 242.073 337.787 242.935 338.873C243.75 339.865 244.333 341.029 244.841 342.202C245.048 342.591 245.051 343.069 245.358 343.401C245.509 343.602 246.249 344.148 246.088 344.342C246.181 344.543 246.872 344.819 246.632 345.014H246.633ZM259.597 339.025L258.094 340.524C257.693 340.924 257.198 341.222 256.662 341.385L256.634 341.393L256.624 341.419C256.449 341.88 256.184 342.29 255.834 342.638L254.331 344.137C253.675 344.791 252.803 345.151 251.874 345.151C250.945 345.151 250.073 344.791 249.417 344.137C248.062 342.786 248.062 340.588 249.417 339.237L250.921 337.737C251.323 337.336 251.805 337.047 252.351 336.88L252.378 336.872L252.388 336.845C252.563 336.385 252.83 335.974 253.18 335.623L254.684 334.124C255.339 333.47 256.211 333.11 257.14 333.11C258.069 333.11 258.942 333.47 259.597 334.124C260.253 334.777 260.614 335.647 260.614 336.574C260.614 337.5 260.253 338.371 259.597 339.024V339.025Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M240.515 343.199C240.383 343.712 240.34 344.585 239.671 344.61C239.617 344.906 239.877 345.018 240.115 344.922C240.349 344.815 240.461 345.007 240.541 345.199C240.903 345.252 241.44 345.078 241.46 344.65C240.919 344.338 240.751 343.746 240.516 343.198L240.515 343.199Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M641.137 359.486C664.132 359.486 682.806 378.127 682.806 401.124C682.806 424.12 664.132 442.761 641.137 442.761C618.142 442.761 599.468 424.12 599.468 401.124C599.468 378.127 618.141 359.486 641.137 359.486Z",
    fill: "#0E0924"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M641.137 359.486C664.132 359.486 682.806 378.127 682.806 401.124C682.806 424.12 664.132 442.761 641.137 442.761C618.142 442.761 599.468 424.12 599.468 401.124C599.468 378.127 618.141 359.486 641.137 359.486Z",
    stroke: "url(#ring-stroke-unified)",
    strokeWidth: 1.17414
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M645.857 395.081V406.592L635.977 400.836V389.325L645.857 395.081Z",
    fill: "#5C4EE5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M646.945 406.592L656.831 400.836V389.325L646.945 395.081V406.592Z",
    fill: "#4040B2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M625.016 394.412L634.896 400.167V388.656L625.016 382.9V394.412ZM645.859 407.854L635.979 402.098V413.605L645.859 419.36V407.854Z",
    fill: "#5C4EE5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M928.715 0.587158C951.71 0.587243 970.384 19.2285 970.384 42.2249C970.384 65.2211 951.71 83.8625 928.715 83.8625C905.72 83.8625 887.046 65.2211 887.046 42.2249C887.046 19.2285 905.72 0.587158 928.715 0.587158Z",
    fill: "#0E0924"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M928.715 0.587158C951.71 0.587243 970.384 19.2285 970.384 42.2249C970.384 65.2211 951.71 83.8625 928.715 83.8625C905.72 83.8625 887.046 65.2211 887.046 42.2249C887.046 19.2285 905.72 0.587158 928.715 0.587158Z",
    stroke: "url(#ring-stroke-unified)",
    strokeWidth: 1.17414
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M948.237 39.5741C945.784 39.5741 943.724 37.9168 943.139 35.6741H937.107C935.821 35.6741 934.723 36.593 934.511 37.8466L934.295 39.129C934.09 40.3465 933.466 41.406 932.585 42.1741C933.466 42.9422 934.09 44.0017 934.295 45.2191L934.511 46.5016C934.723 47.7552 935.821 48.6741 937.107 48.6741H937.876C938.461 46.4314 940.521 44.7741 942.974 44.7741C945.88 44.7741 948.237 47.1022 948.237 49.9741C948.237 52.846 945.88 55.1741 942.974 55.1741C940.521 55.1741 938.461 53.5168 937.876 51.2741H937.107C934.534 51.2741 932.339 49.4363 931.916 46.929L931.699 45.6466C931.488 44.393 930.39 43.4741 929.104 43.4741H927.018C926.434 45.7168 924.373 47.3741 921.921 47.3741C919.469 47.3741 917.408 45.7168 916.824 43.4741H913.861C913.276 45.7168 911.216 47.3741 908.763 47.3741C905.856 47.3741 903.5 45.046 903.5 42.1741C903.5 39.3022 905.856 36.9741 908.763 36.9741C911.216 36.9741 913.276 38.6314 913.861 40.8741H916.824C917.408 38.6314 919.469 36.9741 921.921 36.9741C924.373 36.9741 926.434 38.6314 927.018 40.8741H929.104C930.39 40.8741 931.488 39.9552 931.699 38.7016L931.916 37.4191C932.339 34.9118 934.534 33.0741 937.107 33.0741H943.139C943.724 30.8314 945.784 29.1741 948.237 29.1741C951.144 29.1741 953.5 31.5022 953.5 34.3741C953.5 37.246 951.144 39.5741 948.237 39.5741ZM948.237 36.9741C949.69 36.9741 950.868 35.8099 950.868 34.3741C950.868 32.9382 949.69 31.7741 948.237 31.7741C946.784 31.7741 945.605 32.9382 945.605 34.3741C945.605 35.8099 946.784 36.9741 948.237 36.9741ZM908.763 44.7741C910.216 44.7741 911.395 43.6099 911.395 42.1741C911.395 40.7382 910.216 39.5741 908.763 39.5741C907.31 39.5741 906.132 40.7382 906.132 42.1741C906.132 43.6099 907.31 44.7741 908.763 44.7741ZM924.553 42.1741C924.553 43.6099 923.374 44.7741 921.921 44.7741C920.468 44.7741 919.289 43.6099 919.289 42.1741C919.289 40.7382 920.468 39.5741 921.921 39.5741C923.374 39.5741 924.553 40.7382 924.553 42.1741ZM945.605 49.9741C945.605 51.4099 944.427 52.5741 942.974 52.5741C941.52 52.5741 940.342 51.4099 940.342 49.9741C940.342 48.5382 941.52 47.3741 942.974 47.3741C944.427 47.3741 945.605 48.5382 945.605 49.9741Z",
    fill: "#EA4B71"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1425.17 46.3293C1448.16 46.3294 1466.84 64.9707 1466.84 87.967C1466.84 110.963 1448.16 129.605 1425.17 129.605C1402.17 129.605 1383.5 110.963 1383.5 87.967C1383.5 64.9706 1402.17 46.3293 1425.17 46.3293Z",
    fill: "#0E0924"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1425.17 46.3293C1448.16 46.3294 1466.84 64.9707 1466.84 87.967C1466.84 110.963 1448.16 129.605 1425.17 129.605C1402.17 129.605 1383.5 110.963 1383.5 87.967C1383.5 64.9706 1402.17 46.3293 1425.17 46.3293Z",
    stroke: "url(#ring-stroke-unified)",
    strokeWidth: 1.17414
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_381_3334)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_381_3334",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1404,
    y: 67,
    width: 41,
    height: 41
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1404.5 67.1741H1444.5V107.174H1404.5V67.1741Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_381_3334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1416.15 73.9006L1404.6 96.8707C1404.49 97.0988 1404.47 97.3622 1404.55 97.6037C1404.63 97.8452 1404.8 98.0454 1405.03 98.1607L1411.25 101.287C1411.48 101.401 1411.74 101.42 1411.98 101.34C1412.23 101.26 1412.43 101.088 1412.54 100.861L1424.09 77.8906C1424.2 77.6623 1424.22 77.3986 1424.14 77.1567C1424.06 76.9148 1423.88 76.7143 1423.66 76.599L1417.44 73.4739C1417.32 73.4172 1417.2 73.3833 1417.07 73.3741C1416.95 73.3649 1416.82 73.3807 1416.7 73.4205C1416.58 73.4603 1416.47 73.5233 1416.38 73.606C1416.28 73.6887 1416.2 73.7893 1416.15 73.9023V73.9006Z",
    fill: "url(#paint17_linear_381_3334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1436.57 73.5608H1443.54C1444.07 73.5608 1444.5 73.9941 1444.5 74.5225V100.231C1444.5 100.486 1444.4 100.73 1444.22 100.911C1444.04 101.091 1443.79 101.193 1443.54 101.194H1436.57C1436.32 101.193 1436.07 101.091 1435.89 100.911C1435.71 100.73 1435.61 100.486 1435.61 100.231V74.5241C1435.61 73.9941 1436.04 73.5608 1436.57 73.5608Z",
    fill: "url(#paint18_linear_381_3334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1425.86 73.9823L1420.92 99.0207C1420.87 99.2703 1420.92 99.5289 1421.06 99.7401C1421.2 99.9514 1421.42 100.098 1421.67 100.149L1428.5 101.526C1429.02 101.631 1429.53 101.292 1429.63 100.769L1434.57 75.7323C1434.62 75.4827 1434.57 75.2244 1434.42 75.0133C1434.28 74.8021 1434.06 74.6551 1433.82 74.604L1426.99 73.2256C1426.74 73.1761 1426.48 73.2279 1426.27 73.3697C1426.05 73.5116 1425.91 73.7318 1425.86 73.9823Z",
    fill: "url(#paint19_linear_381_3334)"
  })))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.59 165.962C1177.58 165.962 1196.26 184.604 1196.26 207.6C1196.26 230.596 1177.58 249.237 1154.59 249.238C1131.59 249.238 1112.92 230.596 1112.92 207.6C1112.92 184.603 1131.59 165.962 1154.59 165.962Z",
    fill: "#0E0924"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.59 165.962C1177.58 165.962 1196.26 184.604 1196.26 207.6C1196.26 230.596 1177.58 249.237 1154.59 249.238C1131.59 249.238 1112.92 230.596 1112.92 207.6C1112.92 184.603 1131.59 165.962 1154.59 165.962Z",
    stroke: "url(#ring-stroke-unified)",
    strokeWidth: 1.17414
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_381_3334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1169.74 206.391C1170.09 207.164 1170.31 207.991 1170.4 208.835C1170.49 209.678 1170.45 210.532 1170.27 211.362C1170.09 212.192 1169.78 212.989 1169.35 213.722C1169.06 214.212 1168.73 214.673 1168.35 215.096C1167.97 215.516 1167.54 215.896 1167.08 216.23C1166.61 216.563 1166.12 216.843 1165.59 217.073C1165.07 217.3 1164.53 217.473 1163.97 217.586C1163.7 218.393 1163.31 219.157 1162.81 219.844C1162.31 220.53 1161.7 221.134 1161 221.631C1160.31 222.131 1159.54 222.517 1158.72 222.778C1157.91 223.041 1157.06 223.171 1156.2 223.171C1155.63 223.174 1155.06 223.114 1154.5 223.001C1153.94 222.884 1153.39 222.708 1152.87 222.477C1152.35 222.247 1151.85 221.961 1151.39 221.627C1150.94 221.294 1150.51 220.91 1150.13 220.487C1149.29 220.667 1148.43 220.71 1147.58 220.624C1146.72 220.534 1145.89 220.314 1145.1 219.967C1144.32 219.624 1143.6 219.157 1142.96 218.587C1142.32 218.017 1141.78 217.35 1141.35 216.616C1141.07 216.126 1140.83 215.609 1140.65 215.073C1140.47 214.536 1140.36 213.982 1140.3 213.419C1140.23 212.859 1140.24 212.292 1140.3 211.729C1140.36 211.168 1140.48 210.615 1140.66 210.078C1140.09 209.448 1139.62 208.731 1139.27 207.958C1138.92 207.181 1138.7 206.357 1138.61 205.514C1138.52 204.67 1138.56 203.817 1138.74 202.987C1138.92 202.157 1139.23 201.36 1139.66 200.626C1139.95 200.136 1140.28 199.673 1140.66 199.253C1141.04 198.833 1141.47 198.452 1141.93 198.119C1142.39 197.786 1142.89 197.502 1143.41 197.276C1143.94 197.046 1144.48 196.875 1145.04 196.762C1145.31 195.952 1145.7 195.192 1146.2 194.505C1146.7 193.818 1147.31 193.215 1148.01 192.715C1148.7 192.218 1149.47 191.831 1150.28 191.568C1151.1 191.308 1151.95 191.174 1152.81 191.178C1153.38 191.174 1153.95 191.231 1154.51 191.348C1155.07 191.464 1155.62 191.638 1156.14 191.868C1156.66 192.101 1157.16 192.385 1157.62 192.718C1158.08 193.055 1158.51 193.435 1158.88 193.858C1159.72 193.681 1160.58 193.638 1161.44 193.725C1162.29 193.812 1163.12 194.035 1163.91 194.378C1164.69 194.725 1165.41 195.188 1166.05 195.759C1166.69 196.325 1167.23 196.989 1167.66 197.726C1167.94 198.212 1168.18 198.729 1168.36 199.269C1168.54 199.806 1168.66 200.36 1168.71 200.923C1168.77 201.486 1168.77 202.053 1168.71 202.617C1168.65 203.18 1168.52 203.734 1168.35 204.27C1168.92 204.9 1169.39 205.614 1169.74 206.391ZM1158.52 220.624C1159.25 220.324 1159.92 219.88 1160.48 219.323C1161.04 218.767 1161.49 218.107 1161.79 217.376C1162.1 216.65 1162.26 215.869 1162.26 215.083V207.648C1162.25 207.641 1162.25 207.633 1162.25 207.624C1162.25 207.618 1162.24 207.611 1162.24 207.604C1162.23 207.598 1162.23 207.592 1162.22 207.588C1162.21 207.581 1162.21 207.577 1162.2 207.574L1159.48 206.021V215.003C1159.48 215.093 1159.47 215.186 1159.45 215.273C1159.42 215.363 1159.39 215.446 1159.34 215.526C1159.29 215.606 1159.24 215.679 1159.17 215.743C1159.11 215.807 1159.03 215.863 1158.95 215.909L1152.52 219.587C1152.46 219.62 1152.37 219.667 1152.32 219.694C1152.59 219.917 1152.88 220.114 1153.18 220.287C1153.49 220.46 1153.81 220.607 1154.14 220.727C1154.47 220.844 1154.81 220.934 1155.15 220.994C1155.5 221.054 1155.85 221.084 1156.2 221.084C1156.99 221.084 1157.78 220.927 1158.52 220.624ZM1143.18 215.576C1143.58 216.26 1144.11 216.853 1144.74 217.333C1145.38 217.813 1146.09 218.163 1146.86 218.367C1147.63 218.57 1148.43 218.623 1149.22 218.52C1150.01 218.417 1150.77 218.163 1151.46 217.77L1157.97 214.052L1157.98 214.036C1157.99 214.031 1157.99 214.025 1157.99 214.016C1158 214.009 1158 214.002 1158 213.996V210.862L1150.15 215.359C1150.07 215.406 1149.98 215.439 1149.89 215.466C1149.8 215.489 1149.71 215.499 1149.62 215.499C1149.53 215.499 1149.44 215.489 1149.34 215.466C1149.26 215.439 1149.17 215.406 1149.09 215.359L1142.65 211.679C1142.59 211.645 1142.51 211.595 1142.46 211.565C1142.4 211.909 1142.37 212.255 1142.37 212.602C1142.37 212.949 1142.4 213.296 1142.47 213.639C1142.53 213.979 1142.62 214.316 1142.74 214.643C1142.86 214.969 1143.01 215.283 1143.18 215.583V215.576ZM1141.49 201.673C1141.09 202.357 1140.84 203.11 1140.73 203.89C1140.63 204.67 1140.68 205.461 1140.89 206.224C1141.09 206.984 1141.45 207.694 1141.93 208.321C1142.42 208.945 1143.02 209.468 1143.71 209.862L1150.21 213.582C1150.22 213.585 1150.23 213.587 1150.24 213.589H1150.26C1150.27 213.589 1150.28 213.587 1150.28 213.582C1150.29 213.58 1150.3 213.577 1150.31 213.572L1153.03 212.012L1145.18 207.524C1145.1 207.478 1145.03 207.421 1144.96 207.358C1144.89 207.293 1144.84 207.22 1144.79 207.141C1144.75 207.061 1144.71 206.978 1144.69 206.888C1144.66 206.801 1144.65 206.711 1144.65 206.618V199.046C1144.32 199.166 1144 199.313 1143.7 199.486C1143.4 199.663 1143.11 199.863 1142.84 200.086C1142.57 200.31 1142.32 200.556 1142.1 200.823C1141.87 201.086 1141.67 201.373 1141.5 201.673H1141.49ZM1163.84 206.821C1163.92 206.868 1163.99 206.921 1164.06 206.988C1164.12 207.051 1164.18 207.124 1164.23 207.204C1164.27 207.284 1164.31 207.371 1164.33 207.458C1164.35 207.548 1164.37 207.638 1164.36 207.731V215.303C1165.45 214.909 1166.39 214.219 1167.09 213.312C1167.79 212.405 1168.21 211.322 1168.31 210.188C1168.4 209.055 1168.17 207.914 1167.64 206.904C1167.11 205.894 1166.3 205.054 1165.3 204.487L1158.8 200.766C1158.79 200.764 1158.78 200.762 1158.77 200.76H1158.75C1158.74 200.762 1158.73 200.764 1158.72 200.766C1158.72 200.769 1158.71 200.772 1158.7 200.776L1155.99 202.33L1163.85 206.821H1163.84ZM1166.55 202.787H1166.55V202.79L1166.55 202.787ZM1166.55 202.783C1166.74 201.663 1166.61 200.51 1166.17 199.459C1165.73 198.409 1164.99 197.506 1164.04 196.852C1163.1 196.202 1161.99 195.829 1160.84 195.779C1159.69 195.732 1158.55 196.009 1157.55 196.575L1151.05 200.293C1151.04 200.297 1151.03 200.303 1151.03 200.31L1151.02 200.33C1151.01 200.336 1151.01 200.344 1151.01 200.353C1151.01 200.36 1151.01 200.367 1151.01 200.376V203.484L1158.86 198.993C1158.94 198.946 1159.03 198.913 1159.12 198.886C1159.21 198.863 1159.3 198.853 1159.39 198.853C1159.49 198.853 1159.58 198.863 1159.67 198.886C1159.76 198.913 1159.84 198.946 1159.92 198.993L1166.36 202.673C1166.42 202.707 1166.5 202.753 1166.55 202.783ZM1149.52 199.343C1149.52 199.253 1149.54 199.163 1149.56 199.073C1149.58 198.986 1149.62 198.899 1149.66 198.819C1149.71 198.743 1149.77 198.669 1149.83 198.603C1149.9 198.539 1149.97 198.482 1150.05 198.439L1156.49 194.762C1156.55 194.725 1156.64 194.678 1156.68 194.655C1155.8 193.925 1154.72 193.458 1153.58 193.315C1152.44 193.168 1151.28 193.348 1150.24 193.832C1149.19 194.315 1148.31 195.085 1147.69 196.045C1147.08 197.009 1146.75 198.122 1146.75 199.263V206.698C1146.75 206.706 1146.76 206.714 1146.76 206.721C1146.76 206.728 1146.76 206.734 1146.77 206.741C1146.77 206.748 1146.78 206.754 1146.78 206.761C1146.79 206.765 1146.8 206.77 1146.8 206.774L1149.52 208.328V199.343ZM1151 209.168L1154.5 211.168L1158 209.168V205.171L1154.5 203.17L1151 205.171L1151 209.168Z",
    fill: "#744DFF"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1359.48 310.225C1382.48 310.225 1401.15 328.867 1401.15 351.863C1401.15 374.859 1382.48 393.501 1359.48 393.501C1336.49 393.501 1317.81 374.859 1317.81 351.863C1317.81 328.867 1336.49 310.225 1359.48 310.225Z",
    fill: "#0E0924"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1359.48 310.225C1382.48 310.225 1401.15 328.867 1401.15 351.863C1401.15 374.859 1382.48 393.501 1359.48 393.501C1336.49 393.501 1317.81 374.859 1317.81 351.863C1317.81 328.867 1336.49 310.225 1359.48 310.225Z",
    stroke: "url(#ring-stroke-unified)",
    strokeWidth: 1.17414
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_381_3334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1359.51 334.174C1360.53 334.176 1361.53 334.262 1362.5 334.424V344.904L1369.93 337.493C1370.75 338.076 1371.52 338.724 1372.23 339.432C1372.94 340.14 1373.59 340.908 1374.17 341.726L1366.74 349.137H1377.25C1377.41 350.106 1377.5 351.1 1377.5 352.116V352.14C1377.5 353.157 1377.41 354.152 1377.25 355.122H1366.74L1374.17 362.53C1373.59 363.348 1372.94 364.116 1372.23 364.824H1372.23C1371.52 365.532 1370.75 366.182 1369.93 366.763L1362.5 359.353V369.832C1361.53 369.995 1360.53 370.08 1359.51 370.082H1359.49C1358.47 370.08 1357.47 369.995 1356.5 369.832V359.353L1349.07 366.763C1347.43 365.599 1346 364.166 1344.83 362.53L1352.26 355.122H1341.75C1341.59 354.15 1341.5 353.151 1341.5 352.135V352.083C1341.5 351.819 1341.52 351.497 1341.54 351.163L1341.55 351.063C1341.62 350.125 1341.75 349.137 1341.75 349.137H1352.26L1344.83 341.726C1345.41 340.908 1346.06 340.142 1346.77 339.436L1346.77 339.432C1347.48 338.724 1348.25 338.076 1349.07 337.493L1356.5 344.904V334.424C1357.47 334.262 1358.47 334.176 1359.49 334.174H1359.51ZM1359.51 347.64H1359.49C1358.16 347.64 1356.87 347.885 1355.69 348.33C1355.25 349.508 1355 350.786 1355 352.12V352.137C1355 353.47 1355.25 354.748 1355.69 355.927C1356.87 356.371 1358.16 356.616 1359.49 356.616H1359.51C1360.85 356.616 1362.13 356.371 1363.31 355.927C1363.75 354.746 1364 353.47 1364 352.137V352.12C1364 350.786 1363.75 349.508 1363.31 348.33C1362.13 347.885 1360.85 347.64 1359.51 347.64Z",
    fill: "#FF4A00"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M562.488 62.7498C585.483 62.7498 604.157 81.3911 604.157 104.387C604.157 127.384 585.483 146.025 562.488 146.025C539.493 146.025 520.819 127.384 520.819 104.387C520.819 81.3911 539.493 62.7498 562.488 62.7498Z",
    fill: "#0E0924"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M562.488 62.7498C585.483 62.7498 604.157 81.3911 604.157 104.387C604.157 127.384 585.483 146.025 562.488 146.025C539.493 146.025 520.819 127.384 520.819 104.387C520.819 81.3911 539.493 62.7498 562.488 62.7498Z",
    stroke: "url(#ring-stroke-unified)",
    strokeWidth: 1.17414
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_381_3334",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 561,
    y: 88,
    width: 15,
    height: 34
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M575.761 96.2836L561.977 88.2986V121.112L567.49 117.868V108.635L571.656 111.068L571.595 104.768L567.49 102.335V98.6539L575.761 103.582V96.2836Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_381_3334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M545.68 88.1741H579.496V121.175H545.68V88.1741Z",
    fill: "url(#paint23_linear_381_3334)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_381_3334",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 546,
    y: 88,
    width: 15,
    height: 34
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M546.969 96.2836L560.752 88.2986V121.112L555.239 117.868V98.6539L546.969 103.582V96.2836Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_381_3334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M545.5 88.1741H579.314V121.175H545.5V88.1741Z",
    fill: "url(#paint24_linear_381_3334)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_381_3334",
    x: 692.828,
    y: 104.344,
    width: 222.931,
    height: 222.931,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32.2888
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.141176 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_381_3334"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_381_3334",
    x1: -15,
    y1: 133.416,
    x2: 661.677,
    y2: 133.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_381_3334",
    x1: 64.2344,
    y1: 190.593,
    x2: 645.836,
    y2: 190.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_381_3334",
    x1: 36.0625,
    y1: 291.46,
    x2: 664.615,
    y2: 291.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_381_3334",
    x1: 327.148,
    y1: 364.765,
    x2: 797.242,
    y2: 364.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_381_3334",
    x1: 791.961,
    y1: 78.2907,
    x2: 1269.1,
    y2: 78.2907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_381_3334",
    x1: 1012.05,
    y1: 133.709,
    x2: 1567.24,
    y2: 134.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_381_3334",
    x1: 973.894,
    y1: 199.683,
    x2: 1532.61,
    y2: 199.683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_381_3334",
    x1: 944.558,
    y1: 306.707,
    x2: 1569,
    y2: 306.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#744DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744DFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_381_3334",
    x1: 639.969,
    y1: 174.76,
    x2: 973.356,
    y2: 226.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA892A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E35384"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ring-stroke-unified",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#745EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#745EF0",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#745EF0"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "gradientTransform",
    type: "rotate",
    from: "0 0.5 0.5",
    to: "360 0.5 0.5",
    dur: "6s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_381_3334",
    x1: 103.547,
    y1: 42.2249,
    x2: 185.648,
    y2: 124.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#745EF0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#745EF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_381_3334",
    x1: 131.499,
    y1: 70.0326,
    x2: 147.405,
    y2: 85.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_381_3334",
    x1: 141.162,
    y1: 80.2287,
    x2: 158.216,
    y2: 96.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_381_3334",
    x1: 369.992,
    y1: 170.068,
    x2: 452.093,
    y2: 252.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#745EF0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#745EF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_381_3334",
    x1: 205.664,
    y1: 297.911,
    x2: 287.765,
    y2: 380.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#745EF0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#745EF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_381_3334",
    x1: 600.055,
    y1: 360.073,
    x2: 682.156,
    y2: 442.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#745EF0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#745EF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_381_3334",
    x1: 887.633,
    y1: 1.17407,
    x2: 969.734,
    y2: 83.3378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#745EF0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#745EF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_381_3334",
    x1: 1384.09,
    y1: 46.9163,
    x2: 1466.19,
    y2: 129.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#745EF0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#745EF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_381_3334",
    x1: 1407,
    y1: 99.6741,
    x2: 1424.5,
    y2: 67.1739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#E90CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#C023ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#B02DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B02DE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_381_3334",
    x1: 1404.5,
    y1: 107.174,
    x2: 1444.5,
    y2: 67.1741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B02DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#B02DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#6D00CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D00CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_381_3334",
    x1: 1404.5,
    y1: 107.174,
    x2: 1444.5,
    y2: 67.1739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FF00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#E90CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#C023ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#B02DE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A42BE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#8626D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#6021C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6021C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_381_3334",
    x1: 1113.51,
    y1: 166.549,
    x2: 1195.61,
    y2: 248.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#745EF0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#745EF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_381_3334",
    x1: 1318.4,
    y1: 310.812,
    x2: 1400.5,
    y2: 392.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#745EF0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#745EF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_381_3334",
    x1: 521.406,
    y1: 63.3367,
    x2: 603.507,
    y2: 145.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#745EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#745EF0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#745EF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_381_3334",
    x1: 545.68,
    y1: 104.674,
    x2: 579.496,
    y2: 104.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_381_3334",
    x1: 545.5,
    y1: 104.674,
    x2: 579.316,
    y2: 104.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_381_3334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(128.5 67.1741)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_381_3334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 35,
    fill: "white",
    transform: "translate(395.5 193.174)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_381_3334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(1404.5 67.1741)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_381_3334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(1138.5 191.174)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_381_3334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(1341.5 334.174)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ring-sweep-1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 144.629,
    cy: 83.2756,
    r: 41.669
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ring-sweep-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 411.043,
    cy: 208.893,
    r: 41.669
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ring-sweep-3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 246.714,
    cy: 336.736,
    r: 41.669
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ring-sweep-4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 562.488,
    cy: 104.387,
    r: 41.669
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ring-sweep-5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 928.074,
    cy: 42.8434,
    r: 41.669
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ring-sweep-6"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1425.17,
    cy: 87.967,
    r: 41.669
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ring-sweep-7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1154.59,
    cy: 207.6,
    r: 41.669
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ring-sweep-8"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1359.48,
    cy: 351.863,
    r: 41.669
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechFoundation);
export default __webpack_public_path__ + "static/media/tech_foundation.fd8a48f7f32f44e5cc7fac1f6d332f3a.svg";
export { ForwardRef as ReactComponent };